
const URL = process.env.NODE_ENV === 'production' ? window.abp.url : window.abp.url;
export default URL;